export function AvatarEmptyIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_9127_95708)'>
        <rect width='40' height='40' rx='20' fill='#F3F4F6' />
        <path
          d='M40 34.9902V40.0018H0V35.0085C2.32658 31.8993 5.34651 29.3757 8.81965 27.6386C12.2928 25.9014 16.1233 24.9986 20.0067 25.0018C28.18 25.0018 35.44 28.9252 40 34.9902ZM26.67 15.0002C26.67 16.7683 25.9676 18.464 24.7174 19.7142C23.4671 20.9644 21.7714 21.6668 20.0033 21.6668C18.2352 21.6668 16.5395 20.9644 15.2893 19.7142C14.039 18.464 13.3367 16.7683 13.3367 15.0002C13.3367 13.2321 14.039 11.5364 15.2893 10.2861C16.5395 9.03587 18.2352 8.3335 20.0033 8.3335C21.7714 8.3335 23.4671 9.03587 24.7174 10.2861C25.9676 11.5364 26.67 13.2321 26.67 15.0002Z'
          fill='#D1D5DB'
        />
      </g>
      <rect x='0.5' y='0.5' width='39' height='39' rx='19.5' stroke='#9CA3AF' strokeDasharray='2 2' />
      <defs>
        <clipPath id='clip0_9127_95708'>
          <rect width='40' height='40' rx='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
